var ValueJS = ValueJS || {};

ValueJS.Swiper = function() {

    var _initialized = false;
    var _swipers = [];

    var _selectors = {
        swiper: '.swiper:not(.swiper--custom)'
    };
    var _defaults = {
        loop: false,
        autoplay: false,
        slides: 1,
        spacing: 0,
        direction: 'horizontal',
        pagination: '.swiper-pagination',
        paginationType: 'bullets'
    };

    var _init = function() {
        $(_selectors.swiper).each(function() {
            let el = $(this);

            let navigation = false;
            if (el.data('next-btn') && el.data('prev-btn')) {
                navigation = {
                    nextEl: el.data('next-btn'),
                    prevEl: el.data('prev-btn'),
                    disabledClass: 'text-secondary'
                }
            }

            let breakpoints = {
                0: {slidesPerView: el.data('xs-slides') || el.data('slides') || _defaults.slides, spaceBetween: el.data('xs-spacing') || el.data('spacing') || _defaults.spacing},
                576: {slidesPerView: el.data('sm-slides') || el.data('slides') || _defaults.slides, spaceBetween: el.data('sm-spacing') || el.data('spacing') || _defaults.spacing},
                768: {slidesPerView: el.data('md-slides') || el.data('slides') || _defaults.slides, spaceBetween: el.data('md-spacing') || el.data('spacing') || _defaults.spacing},
                992: {slidesPerView: el.data('lg-slides') || el.data('slides') || _defaults.slides, spaceBetween: el.data('lg-spacing') || el.data('spacing') || _defaults.spacing},
                1200: {slidesPerView: el.data('xl-slides') || el.data('slides') || _defaults.slides, spaceBetween: el.data('xl-spacing') || el.data('spacing') || _defaults.spacing},
                1400: {slidesPerView: el.data('xxl-slides') || el.data('slides') || _defaults.slides, spaceBetween: el.data('xxl-spacing') || el.data('spacing') || _defaults.spacing}
            };

            let swiper = new Swiper(el[0], {
                loop: el.data('loop') || _defaults.loop,
                autoplay: el.data('autoplay') || _defaults.autoplay,
                slidesPerView: el.data('slidesperview') || _defaults.slides,
                spaceBetween: el.data('spacing') || _defaults.spacing,
                direction: el.data('direction') || _defaults.direction,
                navigation: navigation,
                pagination: {
                    el: el.data('pagination') || _defaults.pagination,
                    clickable: true,
                    type: el.data('pagination-type') || _defaults.paginationType,
                },
                pauseOnMouseEnter: true,
                breakpoints: breakpoints,
                on: {
                    afterInit: function(swiper){
                        $('.swiper-slide-active [data-anim-fx]').each(function(){
                            ValueJS.AnimateCSS.animate($(this));
                        });
                        $(_selectors.swiper).find('[data-animate]').each(function(){
                            let el = $(this);
                            if (!el.parents('.swiper-slide').hasClass('swiper-slide-active')) {
                                ValueJS.AnimateCSS.reset(el);
                            }
                        });
                        ValueJS.LazyLoad.domUpdate();
                    },
                    transitionStart: function(swiper){
                        $(_selectors.swiper).find('[data-anim-fx]').each(function(){
                            let el = $(this);
                            if (!el.parents('.swiper-slide').hasClass('swiper-slide-active')) {
                                ValueJS.AnimateCSS.reset(el);
                            }
                        });
                    },
                    transitionEnd: function(swiper){
                        $(_selectors.swiper).find('.swiper-slide.swiper-slide-active [data-anim-fx]').each(function(){
                            ValueJS.AnimateCSS.animate($(this));
                        });
                    }
                }
            });
            _swipers.push(swiper);
        });

        if (!_initialized) {
            _initialized = true;
        }
    }

    var _domUpdate = function() {
        _swipers.forEach(function(swiper) {
            _swiper.destroy();
        });
        _swipers = [];
        _init();
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
        domUpdate : function() {return _domUpdate();}
    };

}();

$(function() {
    // ValueJS.Swiper.init();
});
